import { NavLink } from 'react-router-dom';
import { Card, CardBody, CardFooter, CardText, CardTitle } from 'reactstrap';
import { ICampaignStatsItem, IDonationItem } from '~/types/campaign';
import { formatCurrency } from '~/services/helper';

export interface RecentDonationsCardProps {
    app_items: ICampaignStatsItem[];
}

export const RecentDonationsCard = ({
    app_items,
}: RecentDonationsCardProps) => {
    // get supporters from Stats list
    const stats_supporters = app_items?.find(
        (item) => item.item_type === 'supporters'
    );
    if (!stats_supporters) {
        return <></>;
    }
    const supporters = stats_supporters?.items || [];

    function showItems(items: IDonationItem[]) {
        // show the first 5
        items.splice(5);
        return items?.map((item: IDonationItem, i: number) => {
            return (
                <CardText
                    key={String(i)}
                    className='d-flex justify-content-between border-bottom pb-3'
                    style={{ fontSize: '14px' }}
                >
                    {item.date} {item.name}
                    <div className='text-success fw-bold'>
                        {item.amount ? formatCurrency(item.amount) : '-'}
                    </div>
                </CardText>
            );
        });
    }

    return (
        <Card className='border h-100'>
            <CardBody>
                <CardTitle
                    style={{
                        fontSize: '26px',
                        fontWeight: '900',
                    }}
                >
                    Recent Donations
                </CardTitle>
                {supporters.length > 0
                    ? showItems(supporters)
                    : 'Share your campaign with your closest friends and family to inspire your first donation. '}
            </CardBody>
            {supporters.length > 0 && (
                <CardFooter>
                    <NavLink
                        to='/campaign/supporters/donations'
                        className='btn btn-outline-dark btn-sm'
                    >
                        View All
                    </NavLink>
                </CardFooter>
            )}
        </Card>
    );
};
